// eslint-disable-next-line import/prefer-default-export -- it could be expanded in future
export function fireEvent(stuck, target, scrollContainer, name) {
  const event = new CustomEvent(name, {
    detail: { stuck, target },
  });

  scrollContainer.dispatchEvent(event);
}
